import React from "react"
import { PRODUCT_HIERARCHY_ITEM_TYPES } from "../../constants"
import SubCategoryHeader from "./SubCategoryHeader"
import SubCategoryLinkList from "./SubCategoryLinkList"

const SubCategory = props => {
  if (props.subCategory.type === PRODUCT_HIERARCHY_ITEM_TYPES.CATEGORY) {
    if (props.subCategory.children.length === 0) {
      return (
        <SubCategoryHeader
          subCategory={props.subCategory}
        />
      )
    }
    return (
      <React.Fragment>
        <SubCategoryHeader
          subCategory={props.subCategory}
        />
        <SubCategoryLinkList
          subCategoryChildren={props.subCategory.children}
        />
      </React.Fragment>
    )
  } else {
    return (
      <SubCategoryHeader
        subCategory={props.subCategory}
      />
    )
  }
}

export default SubCategory
